interface ClientCredentials {
  clientId: string;
  clientSecret: string;
}

/**
 * Parses a combined client identifier (format: "clientId:clientSecret") into
 * separate clientId and clientSecret values. Returns null if the format is invalid.
 */
const parseClientIdentifier = (
  identifier: string,
): ClientCredentials | null => {
  const separatorIndex = identifier.indexOf(":");
  if (separatorIndex === -1) {
    return null;
  }

  const clientId = identifier.substring(0, separatorIndex);
  const clientSecret = identifier.substring(separatorIndex + 1);

  if (!clientId || !clientSecret) {
    return null;
  }

  return { clientId, clientSecret };
};

/**
 * Resolves client credentials from an HTML element's dataset.
 * Prefers data-client-id + data-client-secret; falls back to data-client-identifier.
 * Returns null if no valid credentials are found.
 */
export const resolveClientCredentials = (
  dataset: DOMStringMap,
): ClientCredentials | null => {
  if (dataset.clientId && dataset.clientSecret) {
    return { clientId: dataset.clientId, clientSecret: dataset.clientSecret };
  }

  if (dataset.clientIdentifier) {
    return parseClientIdentifier(dataset.clientIdentifier);
  }

  return null;
};
